import { useMemo, useState, useCallback } from 'react';
import { sortRows } from '../../utils/tableSort';

/**
 * Sort state for a list table, shared by the invoicing lists.
 *
 * Per screen, per visit — deliberately not persisted. There is always a way
 * back to the list's own default order (the third click clears the sort), so a
 * user can't get stranded in an ordering they can't undo.
 */
const useTableSort = (columns) => {
  const [sort, setSort] = useState({ key: null, direction: null });

  const onSort = useCallback((key, direction) => {
    setSort(direction ? { key, direction } : { key: null, direction: null });
  }, []);

  // Rows are sorted wherever they came from — the loaded list OR the search
  // results — so the same table never behaves differently in the two modes.
  const applySort = useCallback(
    (rows) => sortRows(rows, sort, columns),
    [sort, columns],
  );

  return useMemo(() => ({ sort, onSort, applySort }), [sort, onSort, applySort]);
};

export default useTableSort;
